import { useMemo } from 'react';
import { useQueries } from '@zg-rentals/react-query5';
import { SatelliteWebLandlordPropertyHandler_getAddressDetails_queryOptions } from '@zg-rentals/ts-satellite-client-react-query';

/**
 * Resolves listing aliases that aren't in the loaded option set to combobox options via
 * getAddressDetails, so selected chips render for listings outside the loaded/paginated results
 * (e.g. a deep-linked alias that loads after the first page).
 */
export default function useSelectedListingOptions(missingAliases: Array<string>) {
  const results = useQueries({
    queries: missingAliases.map((listingAlias) => ({
      ...SatelliteWebLandlordPropertyHandler_getAddressDetails_queryOptions({ listingAlias }),
      staleTime: 5 * 60 * 1000,
      // Don't re-hit getAddressDetails on tab focus for a listing the user may not have access to.
      refetchOnWindowFocus: false,
      meta: {
        context: {
          api: 'getAddressDetails',
          details: 'useSelectedListingOptions - Error fetching selected listing address for chip',
        },
      },
    })),
  });

  return useMemo(
    () =>
      results.flatMap((result, index) =>
        result.data ? [{ value: missingAliases[index], label: result.data.displayAddress }] : [],
      ),
    [results, missingAliases],
  );
}
